const BrokerBenefits = () => {
  const benefits = [
    'Higher margins with wholesale pricing',
    'No fulfillment work required',
    'White label service available',
    'Scale your broker business faster',
    'Professional backend team',
  ];

  return (
    <section className="relative bg-[#F2F4F7] py-24 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute -left-6 top-0 w-1.5 h-48 bg-[#3D8BFF]"></div>
            <h2 className="text-6xl font-bold text-[#2F6FE4] mb-6">Broker Benefits</h2>
            <p className="text-xl text-[#555555]">Everything you need to succeed as a business credit broker</p>
          </div>

          <div className="space-y-8 lg:pl-16">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 opacity-0 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'forwards' }}
              >
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-3xl text-[#3D8BFF]"></i>
                </div>
                <p className="text-[#555555] text-xl font-medium pt-1">{benefit}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Financing Banner */}
        <div className="inline-flex items-center gap-3 bg-white border border-[#A9C9FF] px-6 py-3 rounded-full shadow-md">
          <div className="w-8 h-8 flex items-center justify-center bg-[#A9C9FF] rounded-full flex-shrink-0">
            <i className="ri-money-dollar-circle-fill text-[#2F6FE4] text-lg"></i>
          </div>
          <span className="text-[#555555] font-bold text-base tracking-wide">
            Financing Available — Up to <span className="text-[#3D8BFF]">$100,000</span>
          </span>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://app.flexxbuy.com/fast-funding-capital-llc/apply/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-funds-line text-xl"></i>
            Fund Me
          </a>
          <a
            href="#apply"
            className="border-2 border-[#2F6FE4] text-[#2F6FE4] px-10 py-4 rounded-full font-bold text-lg hover:bg-[#2F6FE4] hover:text-white transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
};

export default BrokerBenefits;